import { RefreshToken } from '../../helper/api';
import { snack } from '../../helper/module/SnackbarUtilsConfigurator';
import { get_refreshToken } from '../../helper/UserData/userdate';
import { httpCustomer } from './axios';

 const queryString = require('query-string');

export class GeocodingApi {

 

  async optimize(params , t , refreshToken) {
    try {

      const response = await httpCustomer.request({
        method: 'post',
        url: '/api/v1/customer/geocoding/optimize',
        data: params,
        headers : refreshToken &&{
              Authorization: "Bearer " + refreshToken,
          
        }
      });

      return response.data.data

    } catch (error) {
 
         if (error.response) {
          snack.ErrorTitleDescSnackbar(JSON.stringify({
            "title": t("Error in optimization"),
            "description": error.response.data.message
          }))
           if (error.response.status === 401 && error.response.data.code == "-9") {
             RefreshToken(() => {
              this.optimize(params , t, get_refreshToken());
             });
             //token exchange
           }
         }
     }


  }


}





